import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateFilterPosition(shouldHideNavbar, announcementHeight, navbarHeight) {
    let topPosition = 0

    if (!shouldHideNavbar) {
      topPosition = navbarHeight - announcementHeight
    }

    this.element.style.top = `${topPosition}px`
  }
}
